var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.exist)?_c('svg',_vm._b({staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(_vm.content)}},'svg',_vm.attributes,false)):_c('span',[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }